import { JSX } from "react";
import { appContext } from "../../../../AppContext";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { IRouterProps, withRouting } from "@iconics/components";
import { Card, GridContainer, GridItem, LayoutContainer, LayoutContent } from "@iconics/components";
import JigsawPieceIcon from "../../../../Components/Icons/JigsawPieceIcon";

class ViewSolutionEnablement extends IbssPage<IProps, IState>
{
    public async componentDidMount(): Promise<void>
    {
        this.pageTitle = appContext().labels.Platform_SolutionEnablement_PageTitle;
    }

    public render(): JSX.Element
    {
        const labels = appContext().labels;

        return (
            <LayoutContainer>
                <LayoutContent>
                    <Card
                        title={labels.Platform_SolutionEnablement_ListTitle}
                        subTitle={labels.Platform_SolutionEnablement_ListSubTitle}
                        icon={<JigsawPieceIcon />}
                    >
                        <GridContainer>
                            <GridItem>
                            </GridItem>
                        </GridContainer>
                    </Card>
                </LayoutContent>
            </LayoutContainer>
        )
    }
}

export default withRouting(ViewSolutionEnablement);
export interface IProps extends IRouterProps { }
export interface IState { }
